import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import RichTextEditor from '../../editor/RichTextEditor';
import { useEffect, useState } from 'react';

const TypeRichTextEditor = ({
  updateValidationOnChange,
  dataCollection,
  field,
  errors = {},
  onPreventEnter,
  sx,
  size,
}) => {
  const { t } = useTranslation();

  const [html, setHtml] = useState('');

  useEffect(() => {
    setHtml(dataCollection[field.key]);
    onPreventEnter(true);
  }, []);

  function handleChange(newHtml) {
    if (countTextCharacters(newHtml) <= 0) {
      updateValidationOnChange(field.key, '');
    } else {
      updateValidationOnChange(field.key, newHtml);
    }
  }

  function countTextCharacters(htmlString) {
    // Create a temporary div element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;

    // Extract the text content from the div element
    const textContent = tempDiv.textContent || tempDiv.innerText || '';

    // Remove extra whitespaces and line breaks, then count the characters
    const plainText = textContent.trim().replace(/\s+/g, ' ');
    const charCount = plainText.length;

    return charCount;
  }

  const hasError = errors[field.key];

  return (
    <RichTextEditor
      startHTML={html}
      setHTML={handleChange}
      hasError={hasError}
    />
  );
};
export default TypeRichTextEditor;
